import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=7fe6f1f4&scoped=true&"
import script from "./Single.vue?vue&type=script&lang=ts&"
export * from "./Single.vue?vue&type=script&lang=ts&"
import style0 from "./Single.vue?vue&type=style&index=0&id=7fe6f1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe6f1f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
